/**
 * Vuely Global Components
 */
/********* DEFAULT GLOBAL COMPONENTS *********/
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AppSectionLoader from "Components/AppSectionLoader/AppSectionLoader";
import { RotateSquare2, Socket } from "vue-loading-spinner";

// delete Confirmation Dialog
import DeleteConfirmationDialog from "Components/DeleteConfirmationDialog/DeleteConfirmationDialog";

// page title bar
import PageTitleBar from "Components/PageTitleBar/PageTitleBar";
// App Card component
import AppCard from "Components/AppCard/AppCard";
// section tooltip
import SectionTooltip from "Components/SectionTooltip/SectionTooltip";

/********* CUSTOM GLOBAL COMPONENTS *********/
// modal print function
import BcModalPrint from "Components/Modals/BcModalPrint";
// modal file upload
import BcFileUpload from "Components/Modals/BcFileUpload";
// modal reorder items
import BcReorder from "Components/Modals/BcReorder";
// Select an address from a list
import BcAddressSelector from "Components/Modals/BcAddressSelector";

// close dialog button
import BcBtnDialogClose from "Components/Buttons/BcBtnDialogClose";
// go back arrow
import BcBtnBack from "Components/Buttons/BcBtnBack";
// add new button
import BcBtnAdd from "Components/Buttons/BcBtnAdd";
// refresh button
import BcBtnRefresh from "Components/Buttons/BcBtnRefresh";
// mobile "more" nav list
import BcBtnMobileNav from "Components/Buttons/BcBtnMobileNav";
// 'clear' button on filter
//import BcBtnFilterClear from "Components/Buttons/BcBtnFilterClear";
// 'search' button on filter
//import BcBtnFilterSearch from "Components/Buttons/BcBtnFilterSearch";
// action buttons on entity dialogs
import BcBtnEntityAction from "Components/Buttons/BcBtnEntityAction";
// mobile tab list
import BcTabs from "Components/Toolbar/BcTabs";

import BcList from "Components/List/BcList";
// transaction links
import BcTransactionLinks from "Components/List/BcTransactionLinks";
// search list
import BcSearchList from "Components/List/BcSearchList";

import BcTooltip from "Components/SectionTooltip/BcTooltip";
// phone input for selecting country code and formating
import BcPhoneInput from "Components/Entity/Phones/BcPhoneInput";
// phone dialog for adding/editing
import BcPhoneDialog from "Components/Entity/Phones/BcPhoneDialog";
// email dialog for adding/editing
import BcEmailDialog from "Components/Entity/Emails/BcEmailDialog";
// address dialog for adding/editing
import BcAddressDialog from "Components/Entity/Addresses/BcAddressDialog";
// notes dialog for adding/editing
import BcNotesDialog from "Components/Entity/Notes/BcNotesDialog";
// notes list with add box
import BcNotesList from "Components/Entity/Notes/BcNotesList";
// pagination buttons
import BcPagination from "Components/Pagination/BcPagination";

import BcSelect from "Components/Elements/BcSelect";
import BcAutocomplete from "Components/Elements/BcAutocomplete";
import BcCombobox from "Components/Elements/BcCombobox";
import BcDialog from "Components/Elements/BcDialog";
import BcPasswordInput from "Components/Elements/BcPasswordInput";
import BcDatePicker from "Components/Elements/BcDatePicker";
import BcTimePicker from "Components/Elements/BcTimePicker";
import BcSearchMenu from "Components/Elements/BcSearchMenu";
import BcSearchInput from "Components/Elements/BcSearchInput";
import BcQuestionField from "Components/Elements/BcQuestionField";

import BcSnackbar from "Components/Snackbar/BcSnackbar";

import BcCircleLoader from "Components/ProgressLoader/BcCircleLoader";
import BcModalOverride from "Components/Modals/BcModalOverride";

import BcModalSupervisorPin from "Components/Modals/BcModalSupervisorPin";

const GlobalComponents = {
    install(Vue) {
        Vue.component("appCard", AppCard);
        Vue.component("sectionTooltip", SectionTooltip);
        Vue.component("deleteConfirmationDialog", DeleteConfirmationDialog);
        Vue.component("vuePerfectScrollbar", VuePerfectScrollbar);
        Vue.component("appSectionLoader", AppSectionLoader);
        Vue.component("pageTitleBar", PageTitleBar);
        Vue.component("rotateSquare2", RotateSquare2);
        Vue.component("socket", Socket);
        Vue.component("bcBtnBack", BcBtnBack);
        Vue.component("bcBtnAdd", BcBtnAdd);
        Vue.component("bcBtnRefresh", BcBtnRefresh);
        Vue.component("bcBtnDialogClose", BcBtnDialogClose);
        Vue.component("bcBtnMobileNav", BcBtnMobileNav);
        //Vue.component("bcBtnFilterClear", BcBtnFilterClear);
        //Vue.component("bcBtnFilterSearch", BcBtnFilterSearch);
        Vue.component("bcBtnEntityAction", BcBtnEntityAction);
        Vue.component("bcTabs", BcTabs);
        Vue.component("bcList", BcList);
        Vue.component("bcModalPrint", BcModalPrint);
        Vue.component("bcFileUpload", BcFileUpload);
        Vue.component("bcReorder", BcReorder);
        Vue.component("bcAddressSelector", BcAddressSelector);
        Vue.component("bcPhoneInput", BcPhoneInput);
        Vue.component("bcPhoneDialog", BcPhoneDialog);
        Vue.component("bcEmailDialog", BcEmailDialog);
        Vue.component("bcAddressDialog", BcAddressDialog);
        Vue.component("bcNotesDialog", BcNotesDialog);
        Vue.component("bcNotesList", BcNotesList);
        Vue.component("bcPagination", BcPagination);
        Vue.component("bcSelect", BcSelect);
        Vue.component("bcAutocomplete", BcAutocomplete);
        Vue.component("bcCombobox", BcCombobox);
        Vue.component("bcDialog", BcDialog);
        Vue.component("bcPasswordInput", BcPasswordInput);
        Vue.component("bcDatePicker", BcDatePicker);
        Vue.component("bcTimePicker", BcTimePicker);
        Vue.component("bcSearchMenu", BcSearchMenu);
        Vue.component("bcSearchInput", BcSearchInput);
        Vue.component("bcQuestionField", BcQuestionField);
        Vue.component("bcTooltip", BcTooltip);
        Vue.component("bcSnackbar", BcSnackbar);
        Vue.component("bcTransactionLinks", BcTransactionLinks);
        Vue.component("bcSearchList", BcSearchList);
        Vue.component("bcCircleLoader", BcCircleLoader);
        Vue.component("bcModalOverride", BcModalOverride);
        Vue.component("bcModalSupervisorPin", BcModalSupervisorPin);
    },
};

export default GlobalComponents;
